import classNames from 'classnames';
import { useMemo } from 'react';
import styled from 'styled-components';

import {
  Currency,
  UserAccountEntryState,
} from '#src/__generated__/globalTypes.ts';
import type { Props as AmountWithConversionProps } from '#src/components/buyActions/AmountWithConversion/index.tsx';
import { AmountWithConversion } from '#src/components/buyActions/AmountWithConversion/index.tsx';
import { isCryptocurrency } from '#src/lib/cryptocurrency.ts';

const Modifier = styled.div`
  text-align: right;
  &.blue {
    color: var(--c-blue-400);
  }
  &.grey {
    color: var(--c-nd-600);
  }
  &.cancelled {
    text-decoration: line-through;
  }
`;

type Props = AmountWithConversionProps & {
  aasmState: UserAccountEntryState;
  positive?: boolean;
};

export const TransactionAmountWithConversion = ({
  aasmState,
  positive,
  ...props
}: Props) => {
  const { primaryCurrency, monetaryAmount } = props;
  const referenceCryptocurrency =
    primaryCurrency === Currency.ETH &&
    isCryptocurrency(monetaryAmount?.referenceCurrency)
      ? monetaryAmount?.referenceCurrency
      : undefined;

  const color = useMemo(() => {
    if (aasmState === UserAccountEntryState.CANCELLED) return 'grey';
    if (positive) return 'blue';
    return '';
  }, [aasmState, positive]);

  return (
    <Modifier className={classNames(color, aasmState.toLowerCase())}>
      <AmountWithConversion
        hideExponent={primaryCurrency === Currency.FIAT}
        withApproxSymbol
        {...props}
        column
        forceCryptocurrency={referenceCryptocurrency}
      />
    </Modifier>
  );
};
